import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { useAtom } from "jotai";

import { maintenanceStatusAtom } from "../atom/maintenance";
import useMaintenanceStatus from "../hooks/useMaintenanceStatus";

const MaintenancePage = () => {
  const [status] = useAtom(maintenanceStatusAtom);
  const { refreshStatus } = useMaintenanceStatus({ enableAuto: false });

  const heading = status.manualLock ? "Scheduled maintenance" : "Temporary outage";
  const description =
    status.message || "Site under maintenance, please come back later!";

  return (
    <Flex
      minH="80vh"
      align="center"
      justify="center"
      bg="gray.900"
      color="gray.50"
      px={6}
      textAlign="center"
    >
      <Box
        maxW="640px"
        bg="gray.800"
        p={10}
        borderRadius="lg"
        boxShadow="lg"
        border="1px solid"
        borderColor="gray.700"
      >
        <Text fontSize="2xl" fontWeight="bold" mb={4}>
          {heading}
        </Text>
        <Text fontSize="lg" mb={6}>
          {description}
        </Text>
      </Box>
    </Flex>
  );
};

export default MaintenancePage;
